import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ActionsComponent } from './actions.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    TranslateModule,
    MatIconModule
  ],
  declarations: [ActionsComponent],
  exports: [ActionsComponent]
})
export class ActionsModule { }
